import React from "react";
import { STATUS_OPTIONS } from "./orderModalCenter.constants";
import {
    filterOrderStatusColor,
    formatDate,
    getLatestCompletedStatus,
    getStatusList,
} from "./orderModalCenter.utils";

function StatusBadge({ status }) {
    if (!status) return null;

    const color = filterOrderStatusColor(status.type || status.text);

    return (
        <div className={`order-status-badge-AO order-status-badge-AO--${color}`}>
            <span />
            <b>{status.shortText || status.text}</b>
        </div>
    );
}

export default function OrderStatusEditor({
    orderDetails,
    selectedStatusType,
    setSelectedStatusType,
}) {
    const statuses = getStatusList(orderDetails);
    const latest = getLatestCompletedStatus(statuses);
    const selectedStatus = STATUS_OPTIONS.find((item) => item.type === selectedStatusType);

    return (
        <div className="order-status-editor-AO">
            <div className="order-status-editor-AO__top">
                <div>
                    <div className="order-status-editor-AO__label">Текущий статус заказа</div>
                    <StatusBadge status={latest} />
                </div>

                <div className="order-status-editor-AO__current-date">
                    <span>Последнее обновление</span>
                    <b>{formatDate(latest?.date)}</b>
                </div>
            </div>

            <div className="order-status-editor-AO__list">
                {statuses.map((status, index) => {
                    const color = filterOrderStatusColor(status.type);
                    const isSelected = selectedStatusType === status.type;
                    const isLatest = latest?.type === status.type;

                    return (
                        <button
                            key={status.type}
                            type="button"
                            className={[
                                "order-status-editor-AO__card",
                                `order-status-editor-AO__card--${color}`,
                                status.isCompleted ? "is-completed" : "is-pending",
                                isSelected ? "is-selected" : "",
                                isLatest ? "is-current" : "",
                            ].filter(Boolean).join(" ")}
                            onClick={() => setSelectedStatusType(status.type)}
                        >
                            <span className="order-status-editor-AO__index">
                                {index + 1}
                            </span>

                            <span className="order-status-editor-AO__body">
                                <span className="order-status-editor-AO__name">
                                    {status.text}
                                </span>

                                <span className="order-status-editor-AO__hint">
                                    {status.hint}
                                </span>

                                <span className="order-status-editor-AO__date">
                                    {status.isCompleted ? formatDate(status.date) : "Ещё не установлен"}
                                </span>
                            </span>

                            <span className="order-status-editor-AO__state">
                                {isSelected ? "Выбран" : isLatest ? "Текущий" : status.isCompleted ? "Пройден" : "Выбрать"}
                            </span>
                        </button>
                    );
                })}
            </div>

            <div className="order-status-editor-AO__bottom">
                <div className="order-status-editor-AO__bottom-title">
                    Новый статус
                </div>

                {selectedStatus ? (
                    <button
                        type="button"
                        className={[
                            "order-status-editor-AO__selected",
                            `order-status-editor-AO__selected--${filterOrderStatusColor(selectedStatus.type)}`,
                        ].join(" ")}
                        onClick={() => setSelectedStatusType("")}
                        title="Сбросить выбранный статус"
                    >
                        <span>{selectedStatus.text}</span>
                        <b>Сбросить</b>
                    </button>
                ) : (
                    <div className="order-status-editor-AO__empty-selected">
                        Нажми на карточку статуса выше
                    </div>
                )}

                <div className="order-status-editor-AO__quick">
                    {STATUS_OPTIONS.map((status) => (
                        <button
                            key={status.type}
                            type="button"
                            className={[
                                "order-status-editor-AO__quick-btn",
                                selectedStatusType === status.type ? "is-active" : "",
                            ].filter(Boolean).join(" ")}
                            onClick={() => setSelectedStatusType(status.type)}
                        >
                            {status.shortText}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}
